var _circle, _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailClicado(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 19.2,
    fill: "#007046",
    stroke: "#007046",
    strokeWidth: 1.6
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 11.3333,
    y: 13.5,
    width: 17.3333,
    height: 13,
    rx: 2,
    stroke: "white",
    strokeWidth: 1.6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3333 16.75L19.1055 20.6361C19.6685 20.9176 20.3313 20.9176 20.8943 20.6361L28.6666 16.75",
    stroke: "white",
    strokeWidth: 1.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailClicado);
export default __webpack_public_path__ + "static/media/email-clicado.c36fd44f26febbcccc6909e423d5e7ad.svg";
export { ForwardRef as ReactComponent };